export const WizardSteps = [
  'title-description',
  'date-time',
  'branding',
   //'speakers',
];

export const KavaStepNames = ['TitleDesc', 'TimeDate', 'Design', 'Speaker'];

const getIndex = (step: string) => {
  const indexOfStep = WizardSteps.indexOf(step);
  return indexOfStep >= 0 ? indexOfStep : 0;
};

export const isLastStep = (step: string) => {
  return getIndex(step) + 1 === WizardSteps.length;
};

export const isFirstStep = (step: string) => {
  return getIndex(step) === 0;
};

export const isCurrentStep = (step: string, index: number) => {
  return getIndex(step) === index;
};

export const getNextStep = (step: string) => {
  return WizardSteps[getIndex(step) + 1];
};

export const getPreviousStep = (step: string) => {
  return getIndex(step) - 1 < 0
    ? WizardSteps[0]
    : WizardSteps[getIndex(step) - 1];
};

export const getKavaStepName = (step: string) => {
  return KavaStepNames[getIndex(step)];
};
